import { useMutation } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import { gql } from '../../__generated__/gql';

export default function useBlockUser({ user }) {
  const toast = useToast();

  const [blockUser, blockUserInfo] = useMutation(FOLLOW_USER_MUTATION, {
    variables: {
      targetUserId: user?.id,
    },
    onCompleted: () => {
      toast({
        title: 'User blocked.',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    },
    optimisticResponse: {
      blockUser: {
        __typename: 'User',
        id: user?.id,
        isBlockedByViewer: true,
      },
    },
  });

  const [unblockUser, unblockUserInfo] = useMutation(UNFOLLOW_USER_MUTATION, {
    variables: {
      targetUserId: user?.id,
    },
    onCompleted: () => {
      toast({
        title: 'User unblocked.',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    },
    optimisticResponse: {
      unblockUser: {
        __typename: 'User',
        id: user?.id,
        isBlockedByViewer: false,
      },
    },
  });

  return {
    blockUser,
    blockUserInfo,
    unblockUser,
    unblockUserInfo,
    isSubmitting: blockUserInfo.loading || unblockUserInfo.loading,
  };
}

const FOLLOW_USER_MUTATION = gql(/* GraphQL */ `
  mutation blockUser($targetUserId: String!) {
    blockUser(targetUserId: $targetUserId) {
      id
      isBlockedByViewer
    }
  }
`);

const UNFOLLOW_USER_MUTATION = gql(/* GraphQL */ `
  mutation unblockUser($targetUserId: String!) {
    unblockUser(targetUserId: $targetUserId) {
      id
      isBlockedByViewer
    }
  }
`);
